import React from 'react'
import Cleave from 'cleave.js/react'
function InputPhone({ value, onChange, ...other }) {
  const options = { blocks: [2, 4, 4], uppercase: true, numericOnly: true }
  return (
    <Cleave
      className="form-control"
      value={value}
      onChange={onChange}
      options={options}
      id="prefix"
      {...other}
    />
  )
}

export default InputPhone
